import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  toggleTheme = new BehaviorSubject<string>(localStorage.getItem('theme') || 'light');
  themeObservable = this.toggleTheme.asObservable();

  constructor(private http: HttpService) {
    this.themeObservable.subscribe((theme) => {
      localStorage.setItem('theme', theme);
    });
  }

  downloadFileFromAzure(path: string, fileName: string) {
    return this.http.downloadFile(`Common/GetCloudBlockBlob?path=${path}&fileName=${encodeURIComponent(fileName)}`);
  }
}
